import { useMemo } from "react";
import { copy } from "shared/assets";

import { IAPIError, IJSONAPIErrorCodes } from "shared/types";

const createGuestCopy = copy.guestlistBlock.guests.create;
const editCopy = copy.guestlistBlock.ticketAndPasses.edit;

export const useGuestlistNumberError = (apiError?: IAPIError | null) => {
  const error = useMemo(() => {
    if (!apiError) return false;

    const { errorCodes } = apiError;

    if (errorCodes.includes(IJSONAPIErrorCodes.TooHighError)) {
      return createGuestCopy.messages.notEnoughTickets;
    }

    if (errorCodes.includes(IJSONAPIErrorCodes.TooLowError)) {
      return editCopy.messages.nbGuestsError;
    }

    return !!apiError;
  }, [apiError]);

  return { error };
};
